import React from 'react'
import { useTranslation } from 'react-i18next'
import { Checkbox, FormControlLabel } from '@mui/material'

const MiscellaneousUpperCaseCheckbox = ({ value, onClick, disabled }) => {
  const { t } = useTranslation()
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={value}
          onChange={onClick}
          color="primary"
          disabled={disabled}
        />
      }
      label={t('miscellaneousUpperCase')}
    />
  )
}

export default MiscellaneousUpperCaseCheckbox
